<button mat-icon-button [style.--h-offset]="hOffset" [style.--v-offset]="vOffset" 
  aria-label="icon-button with a menu" class="card-menu-trigger-btn" matTooltipPosition="above"
  [matTooltip]="getCopyDetailstext()"(click)="onCopyClick()">
  <mat-icon>
      <span class="material-icons">content_copy</span>
  </mat-icon>
</button>
